import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import {
    apiSignIn,
    apiSignUp,
    apiSignInAffiliate,
    apiSignInPatient,
} from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { jwtDecode } from 'jwt-decode'
import { auto } from '@popperjs/core'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            if (resp.data) {
                const { token } = resp.data
                const { userData } = jwtDecode(token)

                dispatch(onSignInSuccess(token))
                if (userData) {
                    let authority = ['admin']
                    if (userData.superAdmin) {
                        console.log('xxxxx')
                        authority = ['super_admin']
                    }
                    console.log(userData.superAdmin)
                    dispatch(
                        setUser(
                            { ...userData, authority } || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['user'],
                                email: '',
                            }
                        )
                    )
                }
                /*navigate(userData.role === 'superadmin' ? appConfig.adminAuthenticatedEntryPath : appConfig.notAdminaAuthenticatedEntryPath)*/
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            console.log(errors)
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        handleSignOut()
    }

    const signInAffiliate = async (values) => {
        try {
            const resp = await apiSignInAffiliate(values)
            if (resp.data) {
                const { token } = resp.data
                const { userData } = jwtDecode(token)

                dispatch(onSignInSuccess(token))
                if (userData) {
                    dispatch(
                        setUser({
                            ...userData,
                            authority: ['affiliate'],
                            userType: 'affiliate',
                        })
                    )
                }
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            console.log(errors)
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signInPatient = async (values) => {
        try {
            const resp = await apiSignInPatient(values)
            if (resp.data) {
                const { token } = resp.data
                const { userData } = jwtDecode(token)

                dispatch(onSignInSuccess(token))
                if (userData) {
                    dispatch(
                        setUser({
                            ...userData,
                            authority: ['patient'],
                            userType: 'patient',
                        })
                    )
                }
                return { status: 'success', message: '' }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const user = useSelector((state) => state.auth.user)

    return {
        authenticated: token && signedIn,
        user,
        userType: user?.userType,
        signIn,
        signUp,
        signOut,
        signInAffiliate,
        signInPatient,
    }
}

export default useAuth
